<div class="questions__container">
  <div class="row"
    [style.minHeight.px]="rowHeight"
    [appHighlight]="highlightColor"
    [defaultColor]="defaultColor"
    (color)="handleMouseEvent( $event)">
    <div class="question" [ngClass]="cssClass">
      <label>{{questionNo}}</label>
      <div class="question-title">
        <p>{{ question }}</p>
        @if (showinfoIcon) {
          <cb-tooltip class="info-icon"
            [explanationText]="getCustomTemplate()">
            <div class="email__container__column__container__infoicon">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <g clip-path="url(#clip0_5552_39256)">
                  <path d="M7.46006 12H8.66006V7.2H7.46006V12ZM7.9997 5.72C8.18661 5.72 8.34339 5.65867 8.47006 5.536C8.59673 5.41333 8.66006 5.26133 8.66006 5.08C8.66006 4.88733 8.59685 4.72583 8.47042 4.5955C8.34398 4.46517 8.18731 4.4 8.00042 4.4C7.81351 4.4 7.65673 4.46517 7.53006 4.5955C7.40339 4.72583 7.34006 4.88733 7.34006 5.08C7.34006 5.26133 7.40327 5.41333 7.5297 5.536C7.65614 5.65867 7.81281 5.72 7.9997 5.72ZM8.00538 16C6.90226 16 5.86559 15.79 4.89538 15.37C3.92517 14.95 3.07673 14.3767 2.35006 13.65C1.62339 12.9233 1.05006 12.0744 0.630061 11.1032C0.210061 10.132 6.10352e-05 9.09425 6.10352e-05 7.99C6.10352e-05 6.88575 0.210061 5.84802 0.630061 4.87682C1.05006 3.90561 1.62339 3.06 2.35006 2.34C3.07673 1.62 3.92567 1.05 4.89688 0.63C5.86808 0.21 6.90581 0 8.01006 0C9.11431 0 10.152 0.21 11.1232 0.63C12.0945 1.05 12.9401 1.62 13.6601 2.34C14.3801 3.06 14.9501 3.90667 15.3701 4.88C15.7901 5.85333 16.0001 6.89156 16.0001 7.99468C16.0001 9.0978 15.7901 10.1345 15.3701 11.1047C14.9501 12.0749 14.3801 12.9221 13.6601 13.6463C12.9401 14.3705 12.0934 14.9439 11.1201 15.3663C10.1467 15.7888 9.1085 16 8.00538 16ZM8.01006 14.8C9.89673 14.8 11.5001 14.1367 12.8201 12.81C14.1401 11.4833 14.8001 9.87667 14.8001 7.99C14.8001 6.10333 14.1413 4.5 12.8238 3.18C11.5063 1.86 9.89839 1.2 8.00006 1.2C6.12006 1.2 4.51673 1.85875 3.19006 3.17624C1.86339 4.49375 1.20006 6.10167 1.20006 8C1.20006 9.88 1.86339 11.4833 3.19006 12.81C4.51673 14.1367 6.12339 14.8 8.01006 14.8Z" [attr.fill]="_ccs.globalColor2"/>
                </g>
                <defs>
                  <clipPath id="clip0_5552_39256">
                    <rect width="16" height="16" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </div>
          </cb-tooltip>
        }
      </div>
      <p class="question__disclaimer">Providing your company’s website can improve your quote outcome.</p>
    </div>
    <div [ngClass]="componentClass" class="button-container">
      <mat-button-toggle-group
        name="{{name}}"
        [(ngModel)]="selectButton"
        (change)="buttonHandler($event)">
        <mat-button-toggle [value]="yes">{{yes}}</mat-button-toggle>
        <mat-button-toggle [value]="no">{{no}}</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>

  @if (showWebAddress) {
    <div class="row"
      [style.minHeight.px]="rowHeight"
      [appHighlight]="highlightColor"
      [defaultColor]="defaultColor"
      (color)="handleMouseEvent( $event)">
      <div class="question" [ngClass]="cssClass">
        <label></label>
        <p>{{subquestiontext}}</p>
      </div>
      <div [ngClass]="componentClass" class="button-container">
        <form class="webform" [formGroup]="WebaddressForm">
          <div cbInput label="Web address"
            hideRequiredMarker="true"
            [errorState]="websiteaddress.invalid && websiteaddress.touched"
            [class.has-error]="websiteaddress.invalid && websiteaddress.touched">
            <input type="text" name="websiteaddress" required
              [formControl]="websiteaddress"
              (input)="checkURLValue($event)" />
            </div>
            @if (websiteaddress.errors?.required && websiteaddress.touched) {
              <div class="help-block">
                Please enter a web address.
              </div>
            }
          </form>
        </div>
      </div>
    }
  </div>
